import { createContext } from 'react';

const TrackingContext = createContext({
  trackEvent: (
    eventName: string,
    fbParams: any,
    gaParams: any,
    applicableMerchants: number[],
  ) => {},
  trackPageView: (params: any) => {},
  trackFBEvent: (
    eventName: string,
    params: any,
    isCustom: boolean,
    applicableMerchants: number[],
  ) => {},
  trackGAEvent: (
    eventName: string,
    params: any,
    applicableMerchants: number[],
  ) => {},
});

export default TrackingContext;
